var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContactForm',{attrs:{"contact":_vm.contact},on:{"submit":function($event){return _vm.onSubmit($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }